import React from 'react'
import { Box, Paper, Tooltip } from '@mui/material'
import { rxGamepad } from '../lib/rx_subject'
import { gamepadButtonName } from '../lib/gamepad'
import './GamepadInput.scss'

const GamepadInput = ({ value, onChange }) => {
  const [focus, setFocus] = React.useState(false)
  const subscription = React.useRef(null)

  const onKeyDown = evt => {
    switch (evt.keyCode) {
      case 8: // backspace
        onChange(null)
    }
  }

  const onFocus = () => {
    setFocus(true)
    subscription.current = rxGamepad.subscribe(button => {
      onChange(button)
    })
  }

  const onBlur = () => {
    setFocus(false)
    if (subscription.current) {
      subscription.current.unsubscribe()
    }
  }

  return (
    <Box className="gamepad-input" tabIndex="0"
         onKeyDown={onKeyDown} onFocus={onFocus} onBlur={onBlur}>
      <Tooltip title={<>ゲームパッドのボタンを押してください<br />バックスペースキーで削除できます</>}
               arrow open={focus} placement="right">
        <Paper className="content">
          {gamepadButtonName(value)}
        </Paper>
      </Tooltip>
    </Box>
  )
}

export default GamepadInput
